import React, { createContext, useContext, useState } from "react";

// Use loader context types
import { ILoaderContextProps } from "./useLoaderContextTypes";

// Loader context initialization
const useLoaderContext = createContext<ILoaderContextProps | undefined>(
  undefined,
);

// Loader provider component
export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const setLoading = (loading: boolean) => setIsLoading(loading);

  return (
    <useLoaderContext.Provider value={{ isLoading, setLoading }}>
      {children}
    </useLoaderContext.Provider>
  );
};

// User loader
export const useLoader = () => {
  const context = useContext(useLoaderContext);
  if (!context)
    throw new Error("useLoader must be used within a LoaderProvider");
  return context;
};
